import React from 'react';

import { ImageSize } from '@nxte-nl/image-hooks';

import { ImagePresentational } from '../../types/common';
import { ImageWithSize } from '../ImageWithSize/ImageWithSize';
import { LayoutWrapper } from '../LayoutWrapper/LayoutWrapper';
import styles from './TopBlockWithImage.module.css';

export type Props = {
  backLink?: JSX.Element;
  image: ImagePresentational | null;
};

export const TopBlockWithImage = React.memo((props: Props) => {
  const { image, backLink } = props;

  return (
    <div className={styles.topBlockWithImage}>
      <LayoutWrapper>
        {backLink && (
          <div className={styles.link}>
            {backLink}
          </div>
        )}

        {image && (
          <div className={styles.imageWrapper}>
            <div className={styles.imageInnerWrapper}>
              <ImageWithSize
                image={image}
                size={ImageSize.XL}
                className={styles.image}
              />
            </div>
          </div>
        )}
      </LayoutWrapper>
    </div>
  );
});

TopBlockWithImage.displayName = 'TopBlockWithImage';
